import {
  all,
  call,
  put,
  select,
  takeEvery
} from 'redux-saga/effects'

import * as Actions from 'actions/persona_library'
import * as AppActions from 'actions/app'
import * as Api from 'api/bff'
import * as Selectors from 'selectors'

export function* createPersona() {
  try {
    const i18n = yield select(Selectors.getI18n)
    const persona = yield select(Selectors.getSelectedPersona)
    const body = {
      name: persona.get('name'),
      description: persona.get('description')
    }

    const result = yield call(Api.createPersona, body)

    yield put(Actions.createPersonaSuccess(result))
    yield put(AppActions.showAppSnackbarMessage({
      text: i18n.get('success'),
      variant: 'success'
    }))
  } catch (error) {
    yield put(Actions.createPersonaError(error))
    yield put(AppActions.genericErrorMessage())
    yield put(AppActions.exception(error))
  }
}

export function* updatePersona() {
  try {
    const i18n = yield select(Selectors.getI18n)
    const persona = yield select(Selectors.getSelectedPersona)
    const body = {
      name: persona.get('name'),
      description: persona.get('description')
    }

    const result = yield call(Api.updatePersona, persona.get('id'), body)

    yield put(Actions.updatePersonaSuccess(result))
    yield put(AppActions.showAppSnackbarMessage({
      text: i18n.get('success'),
      variant: 'success'
    }))
  } catch (error) {
    yield put(Actions.updatePersonaError(error))
    yield put(AppActions.genericErrorMessage())
    yield put(AppActions.exception(error))
  }
}

export function* generatePersonas() {
  try {
    const i18n = yield select(Selectors.getI18n)
    const result = yield call(Api.generatePersonas)

    yield put(Actions.generatePersonasSuccess())
    yield put(Actions.setPersonas(result))
    yield put(AppActions.showAppSnackbarMessage({
      text: i18n.get('success'),
      variant: 'success'
    }))
  } catch (error) {
    yield put(Actions.generatePersonasError(error))
    yield put(AppActions.genericErrorMessage())
    yield put(AppActions.exception(error))
  }
}

export function* watchCreatePersonaStart() {
  yield takeEvery(Actions.createPersonaStart, createPersona)
}

export function* watchUpdatePersonaStart() {
  yield takeEvery(Actions.updatePersonaStart, updatePersona)
}

export function* watchGeneratePersonasStart() {
  yield takeEvery(Actions.generatePersonasStart, generatePersonas)
}

export default function* personaLibrarySaga() {
  yield all([
    watchCreatePersonaStart(),
    watchUpdatePersonaStart(),
    watchGeneratePersonasStart()
  ])
}
